import React from 'react';
import { Link } from 'react-router-dom';
import LegalPageLayout from '../components/LegalPageLayout';

const Accessibility = () => (
  <LegalPageLayout
    title="Accessibility"
    subtitle="Our commitment to making Aurora Wealth Reserves digital experiences usable for everyone."
  >
    <p>
      Aurora Wealth Reserves is committed to providing an accessible digital experience for people with
      disabilities. We aim to conform with the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA
      where reasonably practicable across our public website and online banking interfaces.
    </p>

    <h2>Our Approach</h2>
    <ul>
      <li>Semantic structure and readable typography for clearer navigation</li>
      <li>Keyboard-accessible interactive elements where feasible</li>
      <li>Color contrast that supports readability of primary content</li>
      <li>Ongoing review and remediation as we ship new features</li>
    </ul>

    <h2>Assistive Technologies</h2>
    <p>
      Our pages are designed to work with modern browsers and commonly used assistive technologies.
      Experience may vary by device, browser version, and assistive tool configuration.
    </p>

    <h2>Known Limitations</h2>
    <p>
      Some third-party embeds, legacy documents, or complex interactive banking tools may not yet meet
      every accessibility target. We prioritize fixes based on impact and usage.
    </p>

    <h2>Feedback &amp; Assistance</h2>
    <p>
      If you encounter an accessibility barrier or need information in an alternative format, please contact us:
    </p>
    <ul>
      <li>Email: <a href="mailto:support@aurorawealthreserves.com">support@aurorawealthreserves.com</a></li>
      <li><Link to="/contact">Contact form</Link></li>
    </ul>
    <p>
      Include the page URL, a description of the issue, and the assistive technology you use if applicable.
      We will work with you to provide access to the information or functionality you need.
    </p>
  </LegalPageLayout>
);

export default Accessibility;
